"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9156],{

/***/ 15438:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var keyExistsOn = function keyExistsOn(o, k) {
  return k.split(".").reduce(function (a, c) {
    return a.hasOwnProperty(c) ? a[c] || 1 : false;
  }, Object.assign({}, o)) === false ? false : true;
};

/* harmony default export */ __webpack_exports__["Z"] = (keyExistsOn);

/***/ }),

/***/ 95345:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ accordion_item; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(40037);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
;// CONCATENATED MODULE: ./components/atoms/AccordionBBC/context.js

/** ========== */

var context = /*#__PURE__*/(0,react.createContext)({
  multipleOpen: false
});
/* harmony default export */ var AccordionBBC_context = (context);
/** ========== */
;// CONCATENATED MODULE: ./components/atoms/AccordionBBC/context-item.js

/** ========== */

var contextItem = /*#__PURE__*/(0,react.createContext)({
  eventKey: null,
  open: false
});
/* harmony default export */ var context_item = (contextItem);
/** ========== */
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/AccordionBBC/button.js



var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }



/**
 * Contexts
 */



/** ========== */



var AccordionBBCButton = function AccordionBBCButton(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useContext = (0,react.useContext)(AccordionBBC_context),
      multipleOpen = _useContext.multipleOpen;

  var _useContext2 = (0,react.useContext)(contexts/* AccordionContext */.SY),
      active = _useContext2.active,
      setActive = _useContext2.setActive;

  var _useContext3 = (0,react.useContext)(context_item),
      eventKey = _useContext3.eventKey;

  var handleOnClick = function handleOnClick(clickEvent) {
    var listActive = (0,toConsumableArray/* default */.Z)(active);

    var includes = listActive.includes(clickEvent);

    if (multipleOpen) {
      setActive(includes ? listActive.filter(function (item) {
        return item !== clickEvent;
      }) : [].concat((0,toConsumableArray/* default */.Z)(listActive), [clickEvent]));
    } else {
      setActive(includes ? [] : [clickEvent]);
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    onClick: function onClick() {
      return handleOnClick(eventKey);
    },
    children: children
  }));
};

/* harmony default export */ var AccordionBBC_button = (AccordionBBCButton);
/** ========== */
;// CONCATENATED MODULE: ./components/atoms/AccordionBBC/item.js


var item_excluded = ["eventKey", "children"];

function item_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function item_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { item_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { item_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var Item = function Item(_ref) {
  var eventKey = _ref.eventKey,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, item_excluded);

  var _useContext = (0,react.useContext)(contexts/* AccordionContext */.SY),
      active = _useContext.active;

  var open = active === null || active === void 0 ? void 0 : active.includes(eventKey);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(context_item.Provider, {
    value: {
      eventKey: eventKey,
      open: open
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", item_objectSpread(item_objectSpread({}, props), {}, {
      children: children({
        open: open
      })
    }))
  });
};

/* harmony default export */ var item = (Item);
/** ========== */
;// CONCATENATED MODULE: ./components/atoms/AccordionBBC/panel.js


var panel_excluded = ["children"];

function panel_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function panel_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { panel_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { panel_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var AccordionBBCPanel = function AccordionBBCPanel(_ref) {
  var children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, panel_excluded);

  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(),
      height = _useState[0],
      setHeight = _useState[1];

  var _useContext = (0,react.useContext)(context_item),
      open = _useContext.open;

  var handleHeight = function handleHeight(refParams) {
    setHeight(refParams.current && refParams.current.scrollHeight);
  };

  (0,react.useEffect)(function () {
    handleHeight(ref);
    window.addEventListener("resize", function () {
      return handleHeight(ref);
    });
    return function () {
      window.removeEventListener("resize", function () {
        return handleHeight(ref);
      });
    };
  }, [children]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", panel_objectSpread(panel_objectSpread({}, props), {}, {
    ref: ref,
    className: "overflow-hidden ".concat(props.className),
    style: {
      maxHeight: open ? "".concat(height, "px") : "0px"
    },
    children: children
  }));
};

/* harmony default export */ var panel = (AccordionBBCPanel);
/** ========== */
;// CONCATENATED MODULE: ./components/atoms/AccordionBBC/accordion-item.js


var accordion_item_excluded = ["multipleOpen", "children"];

function accordion_item_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function accordion_item_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { accordion_item_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { accordion_item_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





/** ========== */



var AccordionBBCItem = function AccordionBBCItem(_ref) {
  var multipleOpen = _ref.multipleOpen,
      children = _ref.children,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, accordion_item_excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionBBC_context.Provider, {
    value: {
      multipleOpen: multipleOpen
    },
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", accordion_item_objectSpread(accordion_item_objectSpread({}, props), {}, {
      children: children
    }))
  });
};

/* harmony default export */ var accordion_item = (Object.assign(AccordionBBCItem, {
  Panel: panel,
  Item: item,
  Button: AccordionBBC_button
}));
AccordionBBCItem.defaultProps = {
  multipleOpen: false,
  defaultActiveKey: ""
};
/** ========== */

/***/ }),

/***/ 69156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ molecules_FaqsGroup; }
});

// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(92809);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(91164);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/headlessui.esm.js
var headlessui_esm = __webpack_require__(56727);
// EXTERNAL MODULE: ./common/contexts.js
var contexts = __webpack_require__(72713);
// EXTERNAL MODULE: ./common/lodash/keyExistsOn.js
var keyExistsOn = __webpack_require__(15438);
// EXTERNAL MODULE: ./components/atoms/AccordionBBC/accordion-item.js + 5 modules
var accordion_item = __webpack_require__(95345);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/atoms/AccordionBBC/index.js

var _excluded = ["list", "multipleOpen"];







var AccordionBBC = function AccordionBBC(_ref) {
  var list = _ref.list,
      multipleOpen = _ref.multipleOpen,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var _useContext = (0,react.useContext)(contexts/* AccordionContext */.SY),
      active = _useContext.active;

  return /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_item/* default */.Z, {
    multipleOpen: multipleOpen,
    defaultActiveKey: "".concat(active || ""),
    className: "bbc-accordion ".concat(props.className),
    children: (list === null || list === void 0 ? void 0 : list.length) > 0 && list.map(function (item, index) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_item/* default.Item */.Z.Item, {
        eventKey: "".concat(item.name.toLowerCase().split(" ").join("-")),
        className: "border-b border-[#797979]",
        children: function children(_ref2) {
          var open = _ref2.open;
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(accordion_item/* default.Button */.Z.Button, {
              className: "relative w-full cursor-pointer py-6 text-left text-lg font-medium before:absolute\n                 before:right-3 before:top-1/2 before:h-6  before:w-[1px] before:-translate-y-1/2 before:bg-bbc-gray before:content-[''] after:absolute after:right-3\n                 after:top-1/2 after:h-6 after:w-[1px] after:-translate-y-1/2 after:rotate-90 after:bg-bbc-gray after:content-[''] lg:px-[50px] lg:before:right-10 lg:after:right-10 ".concat(open && "before:rotate-90", " before:transition-all\n                 ").concat(props.buttonClass || ""),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
                className: "pr-6 text-bbc-gray",
                dangerouslySetInnerHTML: {
                  __html: item.name
                }
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(accordion_item/* default.Panel */.Z.Panel, {
              className: "bbc-accordion-panel transition-all lg:px-[50px] ".concat(props.panelClass),
              children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                dangerouslySetInnerHTML: {
                  __html: item.content
                }
              })
            })]
          });
        }
      }, index);
    })
  });
};

/* harmony default export */ var atoms_AccordionBBC = (AccordionBBC);
AccordionBBC.defaultProps = {
  multipleOpen: false,
  list: [],
  defaultActiveKey: null
};
/** ========== */
// EXTERNAL MODULE: ./components/atoms/Title/index.js
var Title = __webpack_require__(31741);
// EXTERNAL MODULE: ./components/molecules/TabListNew/index.js
var TabListNew = __webpack_require__(32144);
;// CONCATENATED MODULE: ./components/molecules/FaqsGroup/index.js


var FaqsGroup_excluded = ["data", "multipleOpen"],
    _excluded2 = ["data", "haveTabs", "defaultActiveKey", "multipleOpen"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var AccordionWithTitle = function AccordionWithTitle(_ref) {
  var data = _ref.data,
      multipleOpen = _ref.multipleOpen,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, FaqsGroup_excluded);

  var checkData = data.some(function (item) {
    return Object.keys(item).length > 0 && (0,keyExistsOn/* default */.Z)(item, "title");
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: checkData ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: data.map(function (item, index) {
          return (0,keyExistsOn/* default */.Z)(item, "title") ? /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
            className: "mt-6 lg:mt-10",
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Title/* default */.Z, {
              text: item.title,
              className: "text-xl font-semibold leading-9 text-bbc-gray"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_AccordionBBC, {
              list: item.data,
              multipleOpen: multipleOpen,
              buttonClass: props.buttonClass,
              panelClass: props.panelClass
            })]
          }, index) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_AccordionBBC, {
            list: [item],
            multipleOpen: multipleOpen,
            buttonClass: props.buttonClass,
            panelClass: props.panelClass
          }, index);
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_AccordionBBC, {
        list: data,
        multipleOpen: multipleOpen
      })
    })
  }));
};

var FaqsGroup = function FaqsGroup(_ref2) {
  var data = _ref2.data,
      haveTabs = _ref2.haveTabs,
      defaultActiveKey = _ref2.defaultActiveKey,
      multipleOpen = _ref2.multipleOpen,
      props = (0,objectWithoutProperties/* default */.Z)(_ref2, _excluded2);

  var _useState = (0,react.useState)([defaultActiveKey]),
      active = _useState[0],
      setActive = _useState[1];

  return /*#__PURE__*/(0,jsx_runtime.jsx)(contexts/* AccordionContext.Provider */.SY.Provider, {
    value: {
      active: active,
      setActive: setActive
    },
    children: haveTabs ? /*#__PURE__*/(0,jsx_runtime.jsx)(TabListNew/* default */.Z, {
      data: data.data.map(function (item) {
        return item.name;
      }),
      activeTab: data.activeTab,
      tabListClass: {
        display: "flex justify-start lg:justify-center lg:flex-wrap",
        length: "w-full",
        padding: "px-1 py-3",
        border: "border-0",
        othersClass: "overflow-x-auto lg:overflow-x-visible"
      },
      tabClass: {
        margin: "mx-1",
        othersClass: "whitespace-nowrap"
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panels */.OK.Panels, {
        children: data.data.map(function (item, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(headlessui_esm/* Tab.Panel */.OK.Panel, {
            className: "focus:outline-none focus:outline-0 focus:ring-0",
            as: "div",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccordionWithTitle, {
              data: item.faqs,
              multipleOpen: multipleOpen,
              className: "mt-4",
              buttonClass: props.buttonClass,
              panelClass: props.panelClass
            })
          }, index);
        })
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(atoms_AccordionBBC, {
      list: data,
      buttonClass: props.buttonClass,
      panelClass: props.panelClass
    })
  });
};

/* harmony default export */ var molecules_FaqsGroup = (FaqsGroup);

/***/ }),

/***/ 32144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(56727);
/* harmony import */ var common_functions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98989);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);







function TabListNew(_ref) {
  var data = _ref.data,
      activeTab = _ref.activeTab,
      tabLinks = _ref.tabLinks,
      tabListClass = _ref.tabListClass,
      tabClass = _ref.tabClass,
      children = _ref.children,
      _onChange = _ref.onChange;
  var tabListStyle = ["rounded-full", tabListClass.display || "flex justify-start lg:justify-center", tabListClass.length || " w-fit mx-auto", tabListClass.background || "bg-transparent", tabListClass.padding || "p-0", tabListClass.border || "border md:border border-bbc-neutral-600", tabListClass.othersClass].join(" ");
  var tabStyle = ["relative select-none rounded-full cursor-pointer border transition-all duration-100 ring-0 outline-none focus:ring-0 focus:outline-0 focus:outline-none text-center", tabClass.width || "w-fit", tabClass.textSize || "text-sm leading-6", tabClass.textFontWeight || "font-semibold", tabClass.padding || "py-3 px-6", tabClass.margin || "", tabClass.othersClass].join(" ");
  /* Handle Event */

  var handleOnClickTabLink = function handleOnClickTabLink(e) {
    e.preventDefault();
    window.history.pushState(null, null, e.target.getAttribute("data-go"));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: "w-full",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.Group */ .OK.Group, {
      defaultIndex: activeTab || 0,
      onChange: function onChange() {
        return _onChange && _onChange();
      },
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab.List */ .OK.List, {
        className: (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabListStyle),
        children: Object.keys(data).length > 0 && data.map(function (item, index) {
          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_2__/* .Tab */ .OK, {
            className: function className(_ref2) {
              var selected = _ref2.selected;
              return (0,common_functions__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)(tabStyle, selected ? "".concat(tabClass.tabColorActive || "border-bbc-brand-500 text-bbc-brand-500") : " ".concat(tabClass.tabColor || "border-transparent bg-transparent text-bbc-neutral-600 hover:text-bbc-brand-500", " "));
            },
            as: "div",
            children: [item.title || item, Array.isArray(tabLinks) && (tabLinks === null || tabLinks === void 0 ? void 0 : tabLinks.length) > 0 ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
              "data-go": "#".concat(tabLinks[index]),
              onClick: handleOnClickTabLink,
              className: "absolute inset-0 h-full w-full"
            }) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {})]
          }, item.id || item);
        })
      }), children]
    })
  });
}

TabListNew.defaultProps = {
  tabListClass: {},
  tabClass: {}
};
/* harmony default export */ __webpack_exports__["Z"] = (TabListNew);

/***/ })

}]);